export const colorsNew = [
  '#4dc9f6',
  '#fbdf9c',
  '#6fcdcd',
  '#e46086',
  '#ac89f3',
  '#f89e7c',
  '#6bb9d7',
  '#ff829d',
  '#9ad0f5',
  '#c07db7'
];

export const tick = {
  fill: '#536283',
  fontSize: '10px'
};
